import { Icon } from "semantic-ui-react";

import "components/NotificationsCenter/components/ClaireNotification/components/NotificationContainer/NotificationContainer.scss";

type NotificationContainerProps = {
  icon: string;
  title?: string;
  description?: string;
  onCloseNotification: () => void;
};

export const NotificationContainer = ({ icon, title, description, onCloseNotification }: NotificationContainerProps) => (
  <div className="NotificationContainer">
    <div className="notification-title">
      <div className="title-container">
        <div>
          <Icon circular className={icon} />
        </div>
        {title && <span className="title">{title}</span>}
      </div>
      {description && (
        <div className="description-container">
          <span>{description}</span>
        </div>
      )}
    </div>

    <div>
      <Icon
        className="xmark"
        onClick={(e: MouseEvent) => {
          e.stopPropagation();
          onCloseNotification();
        }}
      />
    </div>
  </div>
);
